module.exports = __webpack_public_path__ + "img/car_11.0f104800.jpg";